module.exports = __webpack_public_path__ + "img/btn-delete.5b6eef74.png";